const specs = {
  width: 620,
  title: {
    update: 'pages.additionalProvision.modal.update.single.title',
    create: 'pages.additionalProvision.modal.create.single.title'
  },
  okText: {
    update: 'pages.additionalProvision.modal.update.single.okText',
    create: 'pages.additionalProvision.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.additionalProvision.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.additionalProvision.fields.name.title',
        required: 'pages.additionalProvision.fields.name.requiredMessage',
        placeholder: 'pages.additionalProvision.fields.name.placeholder'
      },
      empty: 'common.unknown.female'
    }
  }
}

export default specs
